import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/orphaned/translation.delete.mutation.gql"
import type {
  TranslationDeleteMutation,
  TranslationDeleteMutationVariables,
} from "@/v2-backoffice-client/translation/orphaned/__types__/translation.delete.mutation"

type Options = MutationHookOptions<
  TranslationDeleteMutation,
  TranslationDeleteMutationVariables
>

export function useTranslationDeleteMutation(options?: Options) {
  return useMutation<
    TranslationDeleteMutation,
    TranslationDeleteMutationVariables
  >(mutation, {
    // Soft-deleted codes leave the orphaned list and the catalog board.
    refetchQueries: ["TranslationOrphanedQuery", "TranslationCatalogQuery"],
    ...options,
  })
}
